<template>
  <div class="wm-page">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>外管消息</Breadcrumb-item>
      </Breadcrumb>
    </div>

    <div class="wm-card">
      <div class="wm-tabs">
        <div class="wm-tab" :class="{'wm-tab--active': activeTab==='send'}" @click="switchTab('send')">发送消息</div>
        <div class="wm-tab" :class="{'wm-tab--active': activeTab==='history'}" @click="switchTab('history')">
          发送记录<span class="wm-badge">{{ recordCount }}</span>
        </div>
      </div>

      <div v-show="activeTab === 'send'" class="wm-send">
        <div class="wm-form-row">
          <label class="wm-form-label">接收对象</label>
          <Select v-model.number="formData.sendType" class="wm-select" filterable @on-change="sendTypeChange">
            <Option :value="1">全体中教老师</Option>
            <Option :value="2">全体外教老师</Option>
            <Option :value="3">个人中教老师</Option>
            <Option :value="4">个人外教老师</Option>
            <Option :value="5">全体陪练老师</Option>
            <Option :value="6">个人陪练老师</Option>
            <Option :value="7">全部老师</Option>
            <Option :value="8">欧美外教</Option>
            <Option :value="9">菲教</Option>
            <Option :value="10">指定老师</Option>
          </Select>
        </div>
        <div class="wm-form-row" v-if="showTch">
          <Select v-model="formData.tchIds" class="wm-select" multiple filterable>
            <Option v-for="item in tchList" :value="item.id" :key="item.id">{{item.firstName}} {{item.lastName}}</Option>
          </Select>
        </div>
        <div class="wm-form-row">
          <label class="wm-form-label">消息内容</label>
          <Input v-model="formData.content" type="textarea" :rows="5" placeholder="输入要发送的消息" class="wm-textarea" />
        </div>
        <button class="wm-btn wm-btn-primary" :disabled="buttonLoading" @click="sendMessage">{{ buttonLoading ? '发送中…' : '发 送' }}</button>
      </div>

      <div v-show="activeTab === 'history'" class="wm-history">
        <div v-if="listLoading" class="wm-empty">加载中…</div>
        <table v-else class="wm-table">
          <thead>
            <tr>
              <th>消息内容</th>
              <th>发送对象</th>
              <th>发送时间</th>
              <th>发送人数</th>
              <th>已读</th>
              <th>未读</th>
              <th>阅读率</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!records.length">
              <td colspan="8" class="wm-empty-cell">暂无发送记录</td>
            </tr>
            <tr v-for="row in records" :key="row.id">
              <td class="wm-msg-cell" :title="row.content">{{ row.content }}</td>
              <td>
                <span class="wm-tag" :class="isAllLike(row.sendType) ? 'wm-tag-all' : 'wm-tag-part'">{{ row.targetLabel || sendTypeLabel(row.sendType) }}</span>
                <span v-if="row.resent == 1" class="wm-tag wm-tag-resend">已追发</span>
              </td>
              <td class="wm-num">{{ formatTime(row.gmtCreate) }}</td>
              <td class="wm-num">{{ formatNum(row.totalCount) }}</td>
              <td class="wm-num wm-read">{{ formatNum(row.readCount) }}</td>
              <td class="wm-num" :class="row.unreadCount > 0 ? 'wm-unread' : ''">{{ row.unreadCount > 0 ? formatNum(row.unreadCount) : '—' }}</td>
              <td>
                <span class="wm-rate-bar"><i :style="{width: (row.readRate || 0) + '%'}"></i></span>
                <span class="wm-num">{{ row.readRate || 0 }}%</span>
              </td>
              <td>
                <button class="wm-btn-link" type="button" @click="openDetail(row)">详情</button>
                <button v-if="row.unreadCount > 0" class="wm-btn-link wm-warn" type="button" @click="openResend(row)">对未读人再次发送</button>
                <span v-else class="wm-all-read">全部已读</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="wm-pager" v-if="total > 0">
          <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="onPageChange" />
        </div>
      </div>
    </div>

    <!-- 详情弹窗 -->
    <div class="wm-mask" :class="{show: detailVisible}" @click.self="detailVisible=false">
      <div class="wm-modal" style="width:520px;">
        <div class="wm-modal-head">消息详情 <span class="wm-modal-close" @click="detailVisible=false">×</span></div>
        <div class="wm-modal-body" v-if="detail">
          <p style="margin-bottom:12px;"><b>消息内容：</b>{{ detail.content }}</p>
          <p style="margin-bottom:12px;color:#888;">发送对象：{{ detail.targetLabel || sendTypeLabel(detail.sendType) }} ｜ 发送时间：{{ formatTime(detail.gmtCreate) }}</p>
          <div class="wm-stat-line">
            <div><b>{{ formatNum(detail.totalCount) }}</b>发送人数</div>
            <div><b style="color:#52c41a;">{{ formatNum(detail.readCount) }}</b>已读</div>
            <div><b style="color:#fa541c;">{{ formatNum(detail.unreadCount) }}</b>未读</div>
          </div>
          <p style="margin-bottom:6px;color:#888;">老师阅读明细：</p>
          <div class="wm-teacher-list">
            <div v-for="t in detail.teachers" :key="t.tchId + '-' + t.status" class="wm-teacher-row">
              <span>{{ t.tchName }}</span>
              <span :class="t.status == 1 ? 'wm-st-read' : 'wm-st-unread'">{{ t.statusLabel || (t.status == 1 ? '已读' : '未读') }}</span>
            </div>
            <div v-if="!detail.teachers || !detail.teachers.length" style="padding:12px;color:#999;">暂无明细</div>
          </div>
        </div>
        <div class="wm-modal-foot">
          <button class="wm-btn wm-btn-primary" type="button" @click="detailVisible=false">关 闭</button>
        </div>
      </div>
    </div>

    <!-- 再次发送确认弹窗 -->
    <div class="wm-mask" :class="{show: resendVisible}" @click.self="resendVisible=false">
      <div class="wm-modal" style="width:440px;">
        <div class="wm-modal-head">对未读老师再次发送 <span class="wm-modal-close" @click="resendVisible=false">×</span></div>
        <div class="wm-modal-body" v-if="resendRow">
          <p style="margin-bottom:10px;">即将向本条消息的 <b style="color:#fa541c;">{{ formatNum(resendRow.unreadCount) }} 位未读老师</b> 再次发送：</p>
          <div class="wm-resend-box">{{ resendRow.content }}</div>
          <p style="margin-top:10px;color:#999;font-size:12px;">已读老师不会收到重复消息。</p>
        </div>
        <div class="wm-modal-foot">
          <button class="wm-btn wm-btn-ghost" type="button" style="margin-right:8px;" @click="resendVisible=false">取 消</button>
          <button class="wm-btn wm-btn-primary" type="button" :disabled="resendLoading" @click="confirmResend">{{ resendLoading ? '发送中…' : '确认发送' }}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        activeTab: 'history',
        recordCount: 0,
        tchList: [],
        showTch: false,
        buttonLoading: false,
        listLoading: false,
        resendLoading: false,
        queryParam: { tchType: '' },
        formData: { sendType: '', content: '', tchIds: [] },
        records: [],
        total: 0,
        pageNum: 1,
        pageSize: 20,
        detailVisible: false,
        detail: null,
        resendVisible: false,
        resendRow: null
      }
    },
    mounted () {
      this.loadRecords()
    },
    methods: {
      switchTab (name) {
        this.activeTab = name
        if (name === 'history') {
          this.loadRecords()
        }
      },
      formatTime (val) {
        if (!val) return ''
        if (typeof val === 'string') return val.replace('T', ' ').substring(0, 19)
        try {
          const d = new Date(val)
          if (isNaN(d.getTime())) return String(val)
          const pad = n => (n < 10 ? '0' + n : '' + n)
          return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' +
            pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds())
        } catch (e) {
          return String(val)
        }
      },
      formatNum (n) {
        if (n === null || n === undefined || n === '') return '0'
        return Number(n).toLocaleString()
      },
      sendTypeLabel (sendType) {
        const map = {
          1: '全体中教老师', 2: '全体外教老师', 3: '个人中教老师', 4: '个人外教老师',
          5: '全体陪练老师', 6: '个人陪练老师', 7: '全部老师', 8: '欧美外教', 9: '菲教', 10: '指定老师'
        }
        return map[sendType] || ('类型' + sendType)
      },
      isAllLike (sendType) {
        return sendType === 1 || sendType === 2 || sendType === 5 || sendType === 7 || sendType === 8 || sendType === 9
      },
      sendMessage () {
        let self = this
        if (!self.formData.sendType) {
          self.$Message.warning('请选择接收对象')
          return
        }
        if (!self.formData.content || !String(self.formData.content).trim()) {
          self.$Message.warning('请输入消息内容')
          return
        }
        if (self.showTch && (!self.formData.tchIds || !self.formData.tchIds.length)) {
          self.$Message.warning('请选择老师')
          return
        }
        self.buttonLoading = true
        self.$http.post('/message/sendMessage', {}, {
          transformRequest: [function () {
            return JSON.stringify(self.formData)
          }],
          headers: {'Content-Type': 'application/json;charset=utf-8'}
        }).then(function (res) {
          self.buttonLoading = false
          if (res.data > 0) {
            self.$Message.success('发送成功!')
            self.formData.content = ''
            self.activeTab = 'history'
            self.pageNum = 1
            self.loadRecords()
          }
        }).catch(function () {
          self.buttonLoading = false
        })
      },
      loadRecords () {
        let self = this
        self.listLoading = true
        self.$http.get('/message/batch/list?pageNum=' + self.pageNum + '&pageSize=' + self.pageSize).then(function (res) {
          self.listLoading = false
          let data = res.data || {}
          self.records = data.list || []
          self.total = data.total || 0
          self.recordCount = data.total || 0
        }).catch(function () {
          self.listLoading = false
        })
      },
      onPageChange (p) {
        this.pageNum = p
        this.loadRecords()
      },
      openDetail (row) {
        let self = this
        self.$http.get('/message/batch/detail?batchId=' + row.id + '&pageNum=1&pageSize=200').then(function (res) {
          self.detail = res.data || null
          self.detailVisible = true
        })
      },
      openResend (row) {
        this.resendRow = row
        this.resendVisible = true
      },
      confirmResend () {
        let self = this
        if (!self.resendRow) return
        self.resendLoading = true
        self.$http.post('/message/batch/resend?batchId=' + self.resendRow.id).then(function () {
          self.resendLoading = false
          self.resendVisible = false
          self.$Message.success('已向未读老师再次发送')
          self.loadRecords()
        }).catch(function () {
          self.resendLoading = false
        })
      },
      sendTypeChange (val) {
        let sendType = Number(val)
        this.formData.tchIds = []
        this.tchList = []
        this.showTch = sendType === 3 || sendType === 4 || sendType === 6 || sendType === 10
        if (!this.showTch) {
          return
        }
        let self = this
        if (sendType === 10) {
          self.$http.get('/tch/listByCondition?tchType=1').then(function (res) {
            let list = res.data || []
            self.$http.get('/tch/listByCondition?tchType=2').then(function (res2) {
              let secondList = res2.data || []
              let idMap = {}
              let mergedList = []
              list.concat(secondList).forEach(function (item) {
                if (!idMap[item.id]) {
                  idMap[item.id] = true
                  mergedList.push(item)
                }
              })
              self.tchList = mergedList
            })
          })
          return
        }
        if (sendType === 3) {
          this.queryParam.tchType = 2
        } else if (sendType === 4) {
          this.queryParam.tchType = 1
        } else if (sendType === 6) {
          this.queryParam.tchType = 3
        }
        self.$http.get('/tch/listByCondition?tchType=' + self.queryParam.tchType).then(function (res) {
          if (res.data) {
            self.tchList = res.data
          }
        })
      }
    }
  }
</script>
<style scoped>
.wm-page { font-family: "Microsoft YaHei", "PingFang SC", sans-serif; }
.wm-card {
  background: #fff;
  border-radius: 4px;
  padding: 20px 24px;
  box-shadow: 0 1px 3px rgba(0,0,0,.06);
  margin-top: 8px;
}
.wm-tabs {
  display: flex;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 20px;
}
.wm-tab {
  padding: 10px 20px;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  user-select: none;
  background: transparent !important;
}
.wm-tab.wm-tab--active {
  color: #1890ff;
  border-bottom-color: #1890ff;
  font-weight: 600;
  background: transparent !important;
}
.wm-badge {
  display: inline-block;
  min-width: 18px;
  padding: 0 5px;
  background: #f0f2f5;
  border-radius: 9px;
  font-size: 12px;
  color: #666;
  margin-left: 6px;
  text-align: center;
  line-height: 18px;
}
.wm-tab.wm-tab--active .wm-badge {
  background: #e6f7ff;
  color: #1890ff;
}
.wm-form-row { margin-bottom: 16px; }
.wm-form-label {
  font-size: 13px;
  color: #333;
  margin-bottom: 6px;
  display: block;
}
.wm-select { width: 480px !important; }
.wm-textarea { width: 480px !important; }
.wm-btn {
  display: inline-block;
  padding: 0 18px;
  height: 32px;
  line-height: 30px;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  border: 1px solid transparent;
  background: #fff;
}
.wm-btn:disabled { opacity: .65; cursor: not-allowed; }
.wm-btn-primary { background: #1890ff; color: #fff; border-color: #1890ff; }
.wm-btn-primary:hover:not(:disabled) { background: #40a9ff; border-color: #40a9ff; }
.wm-btn-ghost { border-color: #d9d9d9; color: #333; }
.wm-btn-link {
  background: none;
  border: none;
  color: #1890ff;
  height: auto;
  padding: 0 6px;
  line-height: 1.6;
  font-size: 13px;
  cursor: pointer;
}
.wm-btn-link:hover { color: #40a9ff; text-decoration: underline; }
.wm-btn-link.wm-warn { color: #fa8c16; }
.wm-btn-link.wm-warn:hover { color: #ffa940; }
.wm-all-read { color: #bbb; font-size: 12px; margin-left: 4px; }
.wm-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.wm-table th {
  background: #fafafa;
  color: #333;
  font-weight: 600;
  text-align: left;
  padding: 12px 14px;
  border-bottom: 1px solid #e8e8e8;
  white-space: nowrap;
}
.wm-table td {
  padding: 12px 14px;
  border-bottom: 1px solid #f0f0f0;
  color: #333;
  vertical-align: middle;
}
.wm-table tr:hover td { background: #fafcff; }
.wm-msg-cell {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
}
.wm-num { font-variant-numeric: tabular-nums; }
.wm-read { color: #52c41a; font-weight: 600; }
.wm-unread { color: #fa541c; font-weight: 600; }
.wm-rate-bar {
  width: 90px;
  height: 6px;
  background: #f0f0f0;
  border-radius: 3px;
  overflow: hidden;
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
}
.wm-rate-bar i {
  display: block;
  height: 100%;
  background: #52c41a;
  border-radius: 3px;
}
.wm-tag {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 3px;
  font-size: 12px;
}
.wm-tag-all { background: #e6f7ff; color: #1890ff; }
.wm-tag-part { background: #fff7e6; color: #fa8c16; }
.wm-tag-resend {
  background: #f6ffed;
  color: #52c41a;
  border: 1px solid #b7eb8f;
  margin-left: 4px;
}
.wm-empty, .wm-empty-cell {
  text-align: center;
  color: #999;
  padding: 28px 14px;
}
.wm-pager { margin-top: 12px; text-align: right; }
.wm-mask {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.45);
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.wm-mask.show { display: flex; }
.wm-modal {
  background: #fff;
  border-radius: 6px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 12px rgba(0,0,0,.15);
}
.wm-modal-head {
  padding: 14px 20px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 15px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.wm-modal-close { cursor: pointer; color: #999; font-size: 18px; line-height: 1; }
.wm-modal-body {
  padding: 16px 20px;
  overflow-y: auto;
  font-size: 13px;
  color: #444;
}
.wm-modal-foot {
  padding: 12px 20px;
  border-top: 1px solid #f0f0f0;
  text-align: right;
}
.wm-stat-line {
  display: flex;
  gap: 24px;
  margin-bottom: 14px;
}
.wm-stat-line div { font-size: 13px; }
.wm-stat-line b { font-size: 18px; display: block; }
.wm-teacher-list {
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  max-height: 320px;
  overflow: auto;
}
.wm-teacher-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 14px;
  border-bottom: 1px solid #f5f5f5;
}
.wm-teacher-row:last-child { border-bottom: none; }
.wm-st-read { color: #52c41a; }
.wm-st-unread { color: #fa541c; }
.wm-resend-box {
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 10px 12px;
}
</style>



// WEBPACK FOOTER //
// TeacherManagerMessage.vue?d52152ba